import React from "react";
import { BaseIconProps } from "../../types/styles";

const ToggleOnIcon = ({
    id,
    className,
    size = 1.4,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--primary-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-toggle-on"}
            className={className}
            width={63 / Number(size)}
            height={38 / Number(size)}
            viewBox="0 0 63 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="2" width="63" height="34" rx="17" fill={color} />
            <circle
                cx="44"
                cy="19"
                r="13"
                fill="#ffffff"
                stroke="#dddfe2"
                strokeWidth="1"
            />
        </svg>
    );
};

export default ToggleOnIcon;
